<template>
  <div class="useful">
    <div :class="titleStyle">
      Полезное
    </div>
    
    <div
      v-for="(link, index) in links"
      :key="index"
      class="useful__ad-item"
    >
      <router-link
        v-if="link.internal"
        class="useful__ad-button"
        :to="link.url"
        v-text="link.title"
      />
    
      <a 
        v-if="!link.internal"
        class="useful__ad-button" 
        :href="link.url" 
        target="_blank"
      >
        {{ link.title }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: {
      type: Array,
      default: () => []
    },
    titleStyle: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style src="./../styles/frontpage_useful.css" />
